import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface IDeliveryStep {
  label?: string;
  infoLabel?: string;
  to?: string;
  ref?: any;
}

const StyledDeliveryStep = styled((props) => <Link {...props} />)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95px;

  &:hover {
    cursor: pointer;
  }

  .label {
    font-family: 'DomaineDispCondRegular,sans-serif';
    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.8em;
    font-weight: 100;
  }

  .info-label {
    display: block;
    width: inherit;
    margin-top: 1em;
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
    font-size: 0.8em;
  }
`;

const StyledDeliveryStepSquare = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-image: linear-gradient(to bottom, #c17e54, #f1c087, #b97149) 1;
  border-width: 2px;
  border-style: solid;
`;

export const DeliveryStep: React.FC<IDeliveryStep> = ({
  to,
  label,
  infoLabel
}) => {
  return (
    <StyledDeliveryStep to={to}>
      <StyledDeliveryStepSquare>
        <span className="label">{label}</span>
      </StyledDeliveryStepSquare>

      {infoLabel ? (
        <span
          className="info-label"
          dangerouslySetInnerHTML={{ __html: infoLabel }}
        />
      ) : null}
    </StyledDeliveryStep>
  );
};
